import { api } from "./client";
import type { Profile, Race } from "@/types";

export async function getProfile(): Promise<Profile> {
  const { data } = await api.get<Profile>("/profile");
  return data;
}

export async function updateProfile(patch: Partial<Profile>): Promise<Profile> {
  const { data } = await api.put<Profile>("/profile", patch);
  return data;
}

export interface ZonesPatch {
  swim_css_per_100m_sec?: number | null;
  bike_ftp_watts?: number | null;
  run_threshold_pace_sec_per_km?: number | null;
  run_lthr_bpm?: number | null;
}

export async function updateZones(patch: ZonesPatch): Promise<Profile> {
  const { data } = await api.put<Profile>("/profile/zones", patch);
  return data;
}

export interface RaceCreate {
  name: string;
  type: string;
  date: string;
  priority: "A" | "B" | "C";
  notes?: string | null;
}

export async function addRace(r: RaceCreate): Promise<Race> {
  const { data } = await api.post<Race>("/profile/races", r);
  return data;
}
